import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class PeopleMasterDataService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getEmployeeMasterData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'PeopleMaster/GetEmployeeMasterInfo', data);
  }

  getPositionMasterData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'PeopleMaster/GetPositionMasterData', data);
  }

  getEmployeePositionMappedMasterData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'PeopleMaster/GetEmployeePositionMappedData', data);
  }

  getUserList(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'PeopleMaster/GetUserManagerList', data);
  }

  getUserListForUpdate(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Account/GetUserManagerList', data);
  }

  addEmployee(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'PeopleMaster/SubmitEmployeeMasterInfo', data);
  }

  addPosition(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'PeopleMaster/SubmitPositionMaster', data);
  }

  addEmployeePositionMapped(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'PeopleMaster/SubmitEmployeePositionMap', data);
  }
  getEmployeeMasterList(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'PeopleMaster/GetEmployeeInfoDD', data);
  }
  getPositionDDList(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'PeopleMaster/GetPositionDD', data);
  }
  getAllDepartmentList(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'PeopleMaster/GetDepartmentDD', data);
  }
  getDepartmentData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetDepartmentByPlant', data);
  }

}